/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ space: NonNullable<unknown> }} Chat_Onedata_Delete_Space_IdInputs */



/**
* | output |
* | --- |
* | "ID: {space}" |
*
* @param {Chat_Onedata_Delete_Space_IdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_delete_space_id = /** @type {((inputs: Chat_Onedata_Delete_Space_IdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Delete_Space_IdInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`ID: ${i?.space}`)
	return /** @type {LocalizedString} */ (`ID: ${i?.space}`)
});